import BaseScreen from './BaseScreen';
import NavBar from '../components/NavBar';
import React from 'react';
import { MainNavProps } from './navigation/main/MainParamList';
import { ScrollView, Text, TouchableOpacity, Linking, Platform } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { extractUrls } from '../utils/CommonUtils';
import { black, white, white80 } from '../assets/style/colors';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAppNavigation } from './navigation';

export function HtmlTextScreen({ route }: MainNavProps<'HtmlTextScreen'>) {
	const insets = useSafeAreaInsets();
	const html = route.params.text;
	const title = route.params.title;
	const isHtmlStr = route.params.isHtmlStr;
	const urls = isHtmlStr ? [] : extractUrls(html ?? '');
	const navigation = useAppNavigation();

	const handleTextClick = (isUrl: boolean, text: string) => {
		if (isUrl) {
			if (Platform.OS === 'web') {
				// Web 平台：在新窗口打开
				window.open(text, '_blank', 'noopener,noreferrer');
			} else {
				// 移动平台：导航到 CommonWeb
				navigation.navigate('CommonWeb', {
					url: text,
					showBack: true,
				});
			}
		}
	};

	const handleOpenHtmlInNewWindow = () => {
		if (Platform.OS === 'web' && html) {
			// 创建一个新窗口并写入 HTML
			const newWindow = window.open('', '_blank', 'noopener,noreferrer');
			if (newWindow) {
				newWindow.document.write(html);
				newWindow.document.close();
			}
		}
	};

	return (
		<BaseScreen statusBarColor={isHtmlStr ? white : black} styles={{ backgroundColor: isHtmlStr ? white : black }}>
			<NavBar title={title} showBack={true} style={{ backgroundColor: isHtmlStr ? white : black }} />
			{isHtmlStr === true && (
				<View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
					<Text style={{ fontSize: 16, marginBottom: 20, textAlign: 'center', color: '#333' }}>
						HTML 内容将在新窗口打开
					</Text>
					<TouchableOpacity
						onPress={handleOpenHtmlInNewWindow}
						style={{
							backgroundColor: '#007AFF',
							paddingHorizontal: 30,
							paddingVertical: 15,
							borderRadius: 8,
						}}
					>
						<Text style={{ color: '#fff', fontSize: 16, fontWeight: 'bold' }}>
							在新窗口查看 HTML
						</Text>
					</TouchableOpacity>
				</View>
			)}
			{!isHtmlStr === true && (
				<ScrollView horizontal={false} style={{ flex: 1 }} contentContainerStyle={styles.verticalScrollContent}>
					<View
						style={{
							flexDirection: 'column',
							flex: 1,
							justifyContent: 'center',
							alignItems: 'center',
							backgroundColor: black,
							padding: 10,
						}}
					>
						<View style={[styles.emojiTextView]}>
							{urls.map((v, index) => {
								const isUrl = v.isUrl;
								const text = v.text;

								return (
									<Text
										onPress={() => handleTextClick(isUrl, text)}
										style={{
											color: isUrl ? '#3079ED' : white80,
											fontSize: 20,
											fontFamily: '',
											fontWeight: 'bold',
										}}
										key={`${index}`}
									>
										{text}
									</Text>
								);
							})}
						</View>
					</View>
				</ScrollView>
			)}
		</BaseScreen>
	);
}

const styles = StyleSheet.create({
	emojiTextView: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		paddingHorizontal: 12,
		paddingVertical: 10,
	},
	verticalScrollContent: {
		flexGrow: 1, // 关键属性：让内容容器可以增长
		justifyContent: 'center', // 垂直居中
		alignItems: 'center', // 水平居中
		padding: 20,
	},
});
